import axios from "@/lib/axios";

const getNewLostNonWarranty = () => {
  return axios.get("/facility/flat_rates/lost_non_warranty/new");
}

export default getNewLostNonWarranty;